<template>
  <div class="data-item">
    <div class="data-item_title">各时间段销量</div>

    <div class="data-item_content" ref="chartRef"></div>

    <div class="data-item_empty" v-if="emptyFlag">暂无数据</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chart: null,
      emptyFlag: true,
    };
  },

  props: ["liveData"],

  mounted() {
    window.addEventListener("resize", this.resizeChart);
  },

  methods: {
    setChartOption() {
      if (!this.$refs.chartRef) return;

      this.chart = this.$echarts.init(this.$refs.chartRef);
      const category = this.liveData.time_order_data.time;
      const salesValue = this.liveData.time_order_data.num;

      const options = {
        grid: {
          left: "3%",
          right: "5%",
          bottom: "0%",
          top: "10%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "transparent",
          borderWidth: 0,
          borderColor: "transparent",
          formatter: function (params) {
            return `
              <div class="tooltip-box">
                <div class="tooltip-box_user">${params[0].name}</div>
                <div class="tooltip-box_list">
                  <div class="tooltip-item">
                    <div class="item-label">
                      <i class="icon" style="background: #165DFF"></i>
                      <span>销量</span>
                    </div>

                    <div class="item-value">${params[0].value}</div>
                  </div>
                </div>
              </div>
            `;
          },
        },
        xAxis: {
          type: "category",
          data: category,
          boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "rgba(238,238,238,0.1)",
            },
          },
        },
        series: [
          {
            data: salesValue,
            type: "line",
            smooth: true,
            symbol: "none",
            itemStyle: {
              color: "#165DFF",
            },
          },
        ],
      };

      this.emptyFlag = false;
      this.chart.setOption(options);
    },

    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .tooltip-box {
  width: 121px;
  // height: 135px;
  background: rgba(24, 32, 55, 0.8);
  box-shadow: inset 0px 0px 95px 2px rgba(16, 108, 222, 0.25), inset 0px 0px 10px 2px rgba(0, 114, 255, 0.8);
  border-radius: 4px 4px 4px 4px;
  box-sizing: border-box;
  padding: 10px;

  .tooltip-box_user {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 4px;
  }

  .tooltip-box_list {
    .tooltip-item {
      display: flex;
      justify-content: space-between;
      align-items: center;

      & + .tooltip-item {
        margin-top: 2px;
      }

      .item-label {
        display: flex;
        align-items: center;
        gap: 4px;

        i {
          display: block;
          width: 8px;
          height: 4px;
          border-radius: 2px 2px 2px 2px;
        }

        span {
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
        }
      }

      .item-value {
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
      }
    }
  }
}

.data-item {
  aspect-ratio: 509 / 352;
  position: relative;

  &_content {
    margin-top: 20px;
    height: calc(100% - 36px);
  }

  &_empty {
    height: calc(100% - 56px);
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: #ffffff7e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
